<template>
  <el-tabs v-model="activeTab" type="border-card">
    <el-tab-pane label="Сделки" name="exchanges">
      <LedgerExchangesComponent v-if="activeTab === 'exchanges'" />
    </el-tab-pane>
    <el-tab-pane label="Рабочий стол" name="dashboard">
      <LedgerDashboardComponent v-if="activeTab === 'dashboard'" />
    </el-tab-pane>
    <el-tab-pane label="Балансы" name="balances">
      <LedgerBalancesComponent v-if="activeTab === 'balances'" />
    </el-tab-pane>
    <!-- <el-tab-pane label="Депозиты" name="deposits">
      <LedgerDepositesComponent v-if="activeTab === 'deposits'" />
    </el-tab-pane> -->
    <el-tab-pane label="Валюты" name="valutes">
      <LedgerValutesComponent v-if="activeTab === 'valutes'" />
    </el-tab-pane>
    <el-tab-pane label="Ключи" name="credentials">
      <LedgerCredentialsComponent v-if="activeTab === 'credentials'" />
    </el-tab-pane>
    <el-tab-pane label="Исторические курсы к USDT" name="historical_courses">
      <LedgerHistoricalCoursesComponent v-if="activeTab === 'historical_courses'" />
    </el-tab-pane>
    <el-tab-pane
      v-if="isSuperadmin"
      label="Пресеты комиссии"
      name="commission_presets"
    >
      <LedgerCommissionPresetsComponent v-if="activeTab === 'commission_presets'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapState } from "vuex";
import LedgerExchangesComponent from "../Exchanges";
import LedgerBalancesComponent from "./balances";
// import LedgerDepositesComponent from "./deposites";
import LedgerValutesComponent from "./valutes";
import LedgerCredentialsComponent from "./credentials";
import LedgerDashboardComponent from "./dashboard";
import LedgerHistoricalCoursesComponent from "./historicalCourses";
import LedgerCommissionPresetsComponent from "./commissionPresets";
export default {
  name: "LedgerBalancesIndexComponent",
  data() {
    return {
      activeTab: "exchanges"
    };
  },
  computed: {
    ...mapState("auth", ["session"]),
    isSuperadmin() {
      // Везде в проекте суперадмин-гейт — session.type <= -1 (balances.vue,
      // credentials.vue, valutes.vue), не строгое равенство: тип может быть
      // < -1 у более высоких админ-уровней, и backend (req.user.type >= 1 →
      // 403) их тоже пропускает.
      return !!this.session && this.session.type <= -1;
    }
  },
  components: {
    LedgerExchangesComponent,
    LedgerBalancesComponent,
    // LedgerDepositesComponent,
    LedgerValutesComponent,
    LedgerCredentialsComponent,
    LedgerDashboardComponent,
    LedgerHistoricalCoursesComponent,
    LedgerCommissionPresetsComponent
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/index.vue